import React, { useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import OvertimeFilters from "../components/Overtime/OvertimeFilters";
import OvertimeTable from "../components/Overtime/OvertimeTable";


const AdminOvertimePage = () => {
  const [filters, setFilters] = useState({
    userId: "",
    startDate: "",
    endDate: "",
    status: "",
  });

  const [refreshKey, setRefreshKey] = useState(0);

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    setRefreshKey((prev) => prev + 1); // re-fetch data
  };

  return (
    <MasterLayout>
      <Breadcrumb title="Overtime Management" />

      <div className="container-fluid mt-3">
        {/* Filters */}
        <OvertimeFilters filters={filters} onFilterChange={handleFilterChange} />

        {/* Overtime Table */}
        <div className="mt-4">
          <OvertimeTable key={refreshKey} filters={filters} />
        </div>
      </div>
    </MasterLayout>
  );
};

export default AdminOvertimePage;
